var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3253 39.3615V49.1048H55.1692V29.8574H46.4268V70.0312H55.1692V56.9666H72.3253V70.0312H81.0594V39.3615H72.3253Z",
    fill: "#26A9E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5507 37.434H72.3379V29.8574H105.247V37.434H95.2931V70.0359H86.5548V37.434H86.5507Z",
    fill: "#26A9E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.892 29.8574H142.715L128.893 54.6573C127.744 57.33 126.412 60.0027 124.901 62.6571L126.699 65.7944H130.638L141.745 45.9352L141.799 70.0312H150L149.892 29.8574ZM107.433 29.8574V66.4201C110.651 62.4639 113.394 58.2639 115.634 54.0132V46.4459L117.624 49.9374C118.998 46.8875 120.093 43.8421 120.904 40.8842L114.664 29.862H107.433V29.8574Z",
    fill: "#26A9E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5593 49.9926C8.5593 56.0833 13.2011 61.024 18.9254 61.024H31.1898V54.7033H18.4092V45.5948H39.7616V70.1463H18.9337C8.47603 70.1463 0 61.1252 0 50.0018C0 38.8785 8.47603 29.8574 18.9337 29.8574H55.1941V38.9659H18.9254C13.2011 38.9659 8.5593 43.9019 8.5593 49.9926Z",
    fill: "#26A9E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.069 13.4072C115.151 10.9046 111.308 9.63497 106.633 9.63497C97.0788 9.63497 86.005 14.8148 76.1885 23.5829H63.0581C67.1379 18.9504 71.505 14.939 76.0094 11.6177C90.4762 2.83582 107.441 3.44766 118.069 13.4072Z",
    fill: "#00708E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.692 6.76435C113.361 -4.07839 93.6941 -1.47006 76.0052 11.613C90.4761 2.83116 107.441 3.44298 118.069 13.4025C118.398 13.6969 118.731 14.0143 119.039 14.3409C119.21 14.4973 119.38 14.6814 119.53 14.8608C128.889 25.5103 123.652 49.6661 107.603 68.6421C105.642 70.9652 103.59 73.1273 101.458 75.1238C100.917 75.6344 100.372 76.1312 99.818 76.6327C98.4442 77.8471 97.0496 78.988 95.6341 80.0644C95.5717 80.1104 95.4967 80.1656 95.4301 80.2116C86.8583 86.6566 77.6871 90.3644 69.6065 90.3644C64.6108 90.3644 60.5768 88.9245 57.6044 86.0723C55.1024 83.6802 53.4704 80.4417 52.6753 76.6327H43.5498C43.8579 78.7856 44.3491 80.8373 45.0194 82.774C46.4057 86.8314 48.5746 90.3782 51.5471 93.2303C66.018 107.1 94.1312 98.976 114.335 75.0916C134.534 51.2118 139.167 20.6202 124.692 6.76435Z",
    fill: "#26A9E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4301 80.2164C94.9514 80.635 94.4518 81.0444 93.9481 81.4493C79.3648 93.1706 61.705 95.4938 50.6812 88.1978C46.8595 85.6723 44.245 81.4308 43.5581 76.6972L43.5498 76.6328H52.6753C53.4746 80.4418 55.1024 83.6804 57.6044 86.0725C60.5768 88.9292 64.6108 90.3645 69.6065 90.3645C77.6871 90.3691 86.8583 86.6613 95.4301 80.2164Z",
    fill: "#00708E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApp);
export default __webpack_public_path__ + "static/media/iconApp.09ec915e65f5043b11ff77d20e2293ac.svg";
export { ForwardRef as ReactComponent };